import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const SolutionsPage = lazy(() => import('../pages/solutions/page'));
const MethodPage = lazy(() => import('../pages/method/page'));
const CartasPage = lazy(() => import('../pages/cartas-contempladas/page'));
const EmpresasPage = lazy(() => import('../pages/empresas/page'));
const ConteudosPage = lazy(() => import('../pages/conteudos/page'));
const SobrePage = lazy(() => import('../pages/sobre/page'));
const ContatoPage = lazy(() => import('../pages/contato/page'));
const DiagnosticoPage = lazy(() => import('../pages/diagnostico/page'));
const ConfirmacaoPage = lazy(() => import('../pages/diagnostico/components/ConfirmacaoPage'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const PrivacidadePage = lazy(() => import('../pages/privacidade/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/solucoes',
    element: <SolutionsPage />,
  },
  {
    path: '/metodo',
    element: <MethodPage />,
  },
  {
    path: '/cartas-contempladas',
    element: <CartasPage />,
  },
  {
    path: '/empresas',
    element: <EmpresasPage />,
  },
  {
    path: '/conteudos',
    element: <ConteudosPage />,
  },
  {
    path: '/sobre',
    element: <SobrePage />,
  },
  {
    path: '/contato',
    element: <ContatoPage />,
  },
  {
    path: '/diagnostico',
    element: <DiagnosticoPage />
  },
  {
    path: '/diagnostico/confirmacao',
    element: <ConfirmacaoPage />
  },
  {
    path: '/privacidade',
    element: <PrivacidadePage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;